import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { change } from 'redux-form';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import GraphQL from '../../../GraphQL';
import StudentForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  saveStudentMutation,
  studentExistByCpf,
  studentFindByIdQuery,
} from '../../../shared/queries/Student';
import { menuListByFilterQuery } from '../../../shared/queries/Menu';
import Modal from '../../../shared/components/Modal';
import { getUTCDateFromMilliseconds } from '../../../shared/utils/smartutils';
import { STUDENT_AGREEMENT } from '../../../shared/utils/constants';

const StudentFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({
    id: 0,
    gender: 'O',
    bloodType: { value: 'N.I', label: 'N.I' },
    active: true,
    enrollmentDate: new Date(),
    studentOrigin: STUDENT_AGREEMENT(t)[0],
  });
  const [formOn, setFormOn] = useState(false);
  const [menus, setMenus] = useState([]);
  const [modal, setModal] = useState(false);
  const [replaceStudentDataModal, setReplaceStudentDataModal] = useState(false);
  const [valuesForm, setValuesForm] = useState({});
  const [studentDataFound, setStudentDataFound] = useState({});
  const [historicEnrollments, setHistoricEnrollments] = useState([]);

  function backClickHandler() {
    history.push('/minime/aluno');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const toggleModal = () => {
    setModal(!modal);
  };
  const toggleReplaceStudentDataModal = () => {
    setReplaceStudentDataModal(!replaceStudentDataModal);
  };

  const navigateToStudentForm = () => {
    history.push(`/minime/aluno/mnt/${studentDataFound.id}`);
  };

  const useRegistration = () => {
    toggleReplaceStudentDataModal();
    setDto({ id: 0 });
    navigateToStudentForm();
  };

  const closeStudentAlreadyRegisteredModal = () => {
    dispatch(change('StudentForm', 'cpf', dto.cpf));
    toggleReplaceStudentDataModal();
  };

  function loadMenuToSelect() {
    const filter = {
      id: 0,
      active: true,
      inDetail: false,
      studentQuantity: 0,
      deleted: false,
      filterByStatus: true,
      updaterId: 0,
    };
    const menuQuery = menuListByFilterQuery(filter);
    GraphQL(menuQuery, {})
      .then((res) => {
        const loadedMenus = res.menuListByFilter.map((item) => ({
          ...item,
          value: item.id,
          label: item.name,
        }));
        setMenus(loadedMenus);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  }

  const getValueAndLabelField = (value) => {
    return value.id
      ? {
          ...value,
          value: value.id,
          label: value.name,
        }
      : null;
  };

  function findById(id) {
    showLoading();
    const query = studentFindByIdQuery(id);
    GraphQL(query, {})
      .then((res) => {
        if (res.studentListByFilter) {
          const student = res.studentListByFilter[0];
          setDto({
            ...student,
            bloodType: { value: student.bloodType, label: student.bloodType },
            state: getValueAndLabelField(student.state),
            city: getValueAndLabelField(student.city),
            enrolledMenu:
              student.enrolledMenu && student.enrolledMenu.id
                ? {
                    ...student.enrolledMenu,
                    value: student.enrolledMenu.id,
                    label: student.enrolledMenu.name,
                  }
                : null,
            dateOfBirth: student.dateOfBirth
              ? getUTCDateFromMilliseconds(student.dateOfBirth)
              : new Date(),
            enrollmentDate: new Date(),
            studentOrigin: {
              value: student.studentOrigin,
              label: t(`agreement.${student.studentOrigin}`),
            },
          });
          hideLoading();
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      });
  }

  const handleSubmit = (values) => {
    if (modal) {
      toggleModal();
    }
    setHistoricEnrollments([]);
    const mutation = saveStudentMutation(values);
    showLoading();
    GraphQL(mutation, {
      firstName: values.firstName,
      lastName: values.lastName,
      fullName: values.fullName,
      shortName: values.shortName,
    })
      .then(({ studentSave }) => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        history.push(`/minime/aluno/mnt/${studentSave.id}`);
        findById(studentSave.id);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      });
  };

  const loadExistStudentByCpf = (cpf) => {
    showLoading();
    const filter = {
      id: 0,
      onlyActive: false,
      cpf,
    };
    const query = studentExistByCpf(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.studentListByFilter.length) {
          const student = res.studentListByFilter[0];
          setStudentDataFound(student);
          if (dto.id !== student.id) {
            toggleReplaceStudentDataModal();
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const relatedResponsibleExist = (values) => {
    setValuesForm(values);
    if (values.relatedResponsible.length !== 0) {
      handleSubmit(values);
    } else {
      toggleModal();
    }
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
    loadMenuToSelect();
  }, [dto]);

  return (
    <SmartCard title={t('panels.aluno')}>
      {formOn && (
        <>
          <Modal
            color="warning"
            title={t('notifications.attention')}
            btn="Warning"
            message={t('notifications.save-without-responsible')}
            toggle={toggleModal}
            modal={modal}
            onConfirm={() => handleSubmit(valuesForm)}
          />
          <Modal
            color="warning"
            title={t('notifications.attention')}
            btn="Warning"
            message={t('notifications.student-already-registered')}
            toggle={closeStudentAlreadyRegisteredModal}
            modal={replaceStudentDataModal}
            onConfirm={useRegistration}
          />
          <StudentForm
            onSubmit={relatedResponsibleExist}
            backHandler={backClickHandler}
            dto={dto}
            menus={menus}
            showLoading={showLoading}
            hideLoading={hideLoading}
            historicEnrollments={historicEnrollments}
            setHistoricEnrollments={setHistoricEnrollments}
            loadExistStudentByCpf={loadExistStudentByCpf}
          />
        </>
      )}
    </SmartCard>
  );
};

StudentFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(StudentFormHandler)
);
